"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Card_1 = __importDefault(require("../cards/Card"));
var CardContent_1 = __importDefault(require("../cards/CardContent"));
var List_1 = __importDefault(require("../list/List"));
/**
 * Utility function to help identify if this children passed to the Tabs component is a List.
 *
 * @param {*} children
 */
var isChildAList = function (children) {
    var childCount = react_1.default.Children.count(children);
    var listType = false;
    react_1.default.Children.forEach(children, function (child) {
        if (child.type === List_1.default) {
            listType = true;
        }
    });
    return (childCount === 1 && listType);
};
var areAllChildrenCards = function (children) {
    return react_1.default.Children.toArray(children).every(function (child) { return child.type === Card_1.default; });
};
var TabContent = function (props) {
    var children = props.children, collapsePadding = props.collapsePadding, contentId = props.contentId, selected = props.selected;
    return (react_1.default.createElement(Card_1.default, { id: contentId, classes: classnames_1.default('fds-tab-content', { selected: selected }), "aria-labelledby": contentId + "-title" },
        react_1.default.createElement(CardContent_1.default, { collapsePadding: collapsePadding || isChildAList(children) || areAllChildrenCards(children) }, children)));
};
exports.default = TabContent;
